import { ApiError, isRetryableHttpStatus } from "@tsmono/util";

declare global {
  // Set by e2e tests to skip retry delays

  var __TEST_DISABLE_RETRY: boolean | undefined;
}

export const defaultRetry = (failureCount: number, error: Error): boolean =>
  !globalThis.__TEST_DISABLE_RETRY &&
  failureCount < 3 &&
  !(error instanceof ApiError && !isRetryableHttpStatus(error.status));
